import React from "react";
import { MdTabletMac, MdChangeCircle } from "react-icons/md";
import { BsBank2 } from "react-icons/bs";
import {
  FaMoneyBill,
  FaCarSide,
  FaHandshake,
  FaClinicMedical,
  FaLocationArrow,
  FaPhone,
} from "react-icons/fa";
import { TbVaccineBottle } from "react-icons/tb";
import style from "./Card.module.scss";
import { FiMail } from "react-icons/fi";

const Card2 = ({ onClick, icon, label, bgColor, text }) => {
  const background = () => {
    if (label === "BANK TRANSFER") return "#292929";
    if (label === "HMO") return "green";
    if (label === "CASH ON DELIVERY") return "#0958CE";
    if (label === "CHEQUE") return "#AC1B1B";
    if (label === "REFILL") return "lightBlue";
    if (label === "EXCHANGE") return "lightGreen";
    if (label === "DROP OFF") return "lightRed";
    if (label === "ADDRESS") return "lightRed";
    if (label === "CLASS") return "lightRed";
    if (label === "PHONE NUMBER") return "lightRed";
    if (label === "OXYGEN") return "lightBlue";
    if (label === "BLOOD") return "lightRed";
  };

  const icons = () => {
    if (label === "BANK TRANSFER")
      return <MdTabletMac size={70} color="#fff" />;
    if (label === "CASH ON DELIVERY")
      return <FaMoneyBill size={70} color="#fff" />;
    if (label === "CHEQUE") return <BsBank2 size={70} color="#fff" />;
    if (label === "HMO") return <FaClinicMedical size={70} color="#fff" />;
    if (label === "REFILL")
      return <TbVaccineBottle size={70} color="#0779F7" />;
    if (label === "EXCHANGE")
      return (
        <FaHandshake
          size={70}
          color="green"
          style={{ transform: "rotate(-45deg)" }}
        />
      );
    if (label === "DROP OFF") return <FaCarSide size={70} color="#B70303" />;
    if (label === "ADDRESS")
      return <FaLocationArrow size={70} color="#B70303" />;
    if (label === "CLASS") return <MdChangeCircle size={70} color="#B70303" />;
    if (label === "PHONE NUMBER") return <FaPhone size={70} color="#B70303" />;
    if (label === "EMAIL") return <FiMail size={70} color="#B70303" />;
    if (label === "OXYGEN")
      return <FaClinicMedical size={70} color="#B70303" />;
    if (label === "BLOOD") return <FaClinicMedical size={70} color="#B70303" />;
  };
  return (
    <div>
      <div
        className="d-flex text-center flex-column"
        style={{ textDecoration: "none", cursor: "pointer" }}
        onClick={() => onClick()}
      >
        <div
          className={style.card}
          style={{ backgroundColor: (bgColor = background()) }}
        >
          {" "}
          {(icon = icons())}
          {text && <h2>{text}</h2>}
        </div>
        <p className={style.label}>{label}</p>
      </div>
    </div>
  );
};

export default Card2;
